import { Button, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import Fieldset from "components/form/Fieldset";
import AddIcon from "@mui/icons-material/Add";
import GeolocationButton from "components/form/input/GeolocationButton";
import ListInput from "components/form/input/ListInput";
import { NestedField, useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import { useCoordinates } from "util/geolocation";
import FormRow from "components/form/FormRow";
import ApontamentoImages from "./ApontamentoImages";

export default function ApontamentoPontosdeColetas({ visita, name = "pontosColetas", label = "Pontos", children }) {
    const [coordinates] = useCoordinates();
    let [pontos, setPontos] = useFieldValue(name);
    const theme = useTheme()
    function addItem() {
        const newItem = {};
        newItem.georeferencia = coordinates;
        setPontos([...pontos, newItem]);


    }

    // function removeItem(index) {
    //     const removed = pontos.splice(index, 1)[0];
    //     setPontos([...pontos]);
    //     if (removed.image) {
    //         handleRemoveImage(removed.image);
    //     }
    // }

    function onAdd(item) {
        item.georeferencia = coordinates;
    }

    function onRemove(item) {
        if (item.image) {
            handleRemoveImage(item.image);
        }
    }


    function handleRemoveImage(image) {
        if (image.uid) {
            visita.deleteImage(image.uid);
        }
    }
    
    return (<>

        <Fieldset label={label} fullWidth sx={{ ". fieldset": { flex: 1, border: "1px solid", borderColor: theme.palette.grey[400], p: 0 }, }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
                <Button variant="outlined" startIcon={<AddIcon />} onClick={() => addItem()}>
                    Ponto
                </Button>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", pl: -1 }}>
                {(pontos || []).map((ponto, index) => {

                    return (<NestedField key={index} prefix={name} index={index}>
                        <Fieldset key={index} label={"Ponto " + (index + 1)} fullWidth>
                            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
                                <ListInput name={"coletas"} label={"Coletas"} labelButton={"Coleta"} onAdd={onAdd} onRemove={onRemove} fullWidth>
                                    {children}
                                </ListInput>
                                <FormRow>
                                    <TextInput
                                        sx={{ "& input": { fontWeight: "bold" } }}
                                        name="conformidade"
                                        label={"Conformidade Ponto (%)"}
                                        disabled
                                    />

                                    <GeolocationButton name="georeferencia" />
                                </FormRow>

                                <ApontamentoImages visita={visita} label="Imagens do Ponto" name="images" />
                            </Box>
                        </Fieldset>
                    </NestedField>)
                })}
            </Box>

        </Fieldset>

        {/* // <ListInput name={name} label={label} onAdd={onAdd} onRemove={onRemove} fullWidth>
        //     <Fieldset label='Ponto' >
        //         {children}
        //         <TextInput name="observacao" label="Observação" />
        //         <GeolocationButton name="georeferencia" label="Rota Maps" icon />
        //     </Fieldset>

        // </ListInput>
        // <ListInput name="coletas" label={label} onAdd={onAdd} onRemove={onRemove} fullWidth>
        //     {children}

        //     <TextInput name="observacao" label="Observação" />
        //     <ImageInput name="image" label="Foto" onRemove={handleRemoveImage} small />
        //     <CheckboxInput name="confirmaRelatorio" label="Relatório" />
        //     <GeolocationButton name="georeferencia" label="Rota Maps" icon />
        // </ListInput> */}
    </>
    )
}
